// app/providers.js
'use client';
import { MotionConfig } from 'motion/react';
import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { getToken } from '@/services/_utils';
import { identifyFromToken } from '@/analytics/identify';
import { schedulePostHogLoad, withPostHog } from '@/analytics/posthogClient';

// Re-checked on navigation so a client-side login is picked up; reset happens on logout (goToLoginPage).
// Queued until posthog-js has lazy-loaded; the token is read when it runs.
function PostHogIdentify() {
  const pathname = usePathname();
  useEffect(() => {
    withPostHog((ph) => identifyFromToken(ph, getToken()));
  }, [pathname]);
  return null;
}

export function CSPostHogProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    schedulePostHogLoad();
  }, []);
  return (
    <>
      <PostHogIdentify />
      {children}
    </>
  );
}

// Wrapping it in ProductAnalyticsProvider
// If another product analytic solution is intend to be use, place it inside here with logic
export function ProductAnalyticsProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  // reducedMotion="user" makes all motion/react animations honor the OS
  // "reduce motion" accessibility setting (WCAG 2.3.3).
  const content = <MotionConfig reducedMotion="user">{children}</MotionConfig>;

  if (process.env.NEXT_PUBLIC_POSTHOG_KEY) {
    return <CSPostHogProvider>{content}</CSPostHogProvider>;
  }

  return content;
}
